<ng-container *ngIf="modalService.getActiveContentTemplate(modalId) | async as contentTemplate">
  <udex-modal
    [open]="!!contentTemplate"
    class="default-modal"
    [dcpJoinClasses]="(modalService.getActiveOptions(modalId) | async)?.customClasses"
    [classesPrefix]="(modalService.getActiveOptions(modalId) | async)?.classesPrefix ?? 'default-modal--'"
    [classesPostfix]="(modalService.getActiveOptions(modalId) | async)?.classesPostfix"
    [class.wide]="(modalService.getActiveOptions(modalId) | async)?.wide"
    [type]="(modalService.getActiveOptions(modalId) | async)?.type ?? 'default'"
  >
    <div
      *ngIf="(modalService.getActiveOptions(modalId) | async)?.showHeader === true"
      slot="header"
      design="Header"
      class="default-modal__header d-flex flex-nowrap justify-content-between align-items-center"
    >
      <h3
        *ngIf="modalService.getActiveTitle(modalId) | async as headerTitle"
        class="default-modal__header__title heading__medium--xs"
      >{{headerTitle}}</h3>
      <udex-control-button
        class="default-modal__header__close-button"
        size="Large"
        design="Tertiary"
        icon="decline"
        [accessibleName]="'common.close' | cxTranslate"
        accessible-role="Button"
        slot="endContent"
        (click)="closeModal()"
      ></udex-control-button>
    </div>

    <div
      class="default-modal__content"
    >
      <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
    </div>

    <div
      *ngIf="modalService.getActiveFooterTemplate(modalId) | async as footerTemplate"
      class="default-modal__footer"
      slot="footer"
      design="Footer"
    >
      <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
    </div>
  </udex-modal>
</ng-container>
